import { yupResolver } from "@hookform/resolvers/yup"
import { Divider, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import * as Yup from "yup"

import api from "apis"
import { jewlr_t } from "helpers/application"

import {
  FormContainer,
  FormWrapper,
  Text,
  CancelButton,
  InputWrapper,
  SubmitButton,
} from "../components"
import Heading from "../heading"

import ShipMethods from "./ship-methods"

const schema = Yup.object().shape({
  ship_method_id: Yup.string().required(
    `Please select a ${jewlr_t("terms.shipping")} method`
  ),
})

const OrderForm = ({ orderData, setCompleted }) => {
  const navigate = useNavigate()
  const {
    control,
    formState: { errors, isSubmitting, isValid },
    handleSubmit,
    setError,
  } = useForm({
    defaultValues: {
      ship_method_id: "",
    },
    mode: "onBlur",
    resolver: yupResolver(schema),
  })

  const onSubmit = async (values) => {
    const response = await api.post(
      "/secure/api/v10/order/select_shipping_method",
      {
        order_number: orderData.order.number,
        order_token: orderData.order.token,
        ship_method_id: values.ship_method_id,
      }
    )
    if (response?.errors) {
      setError("root.error", {
        message:
          response?.errors?.[0] ||
          response?.errors?.message ||
          response?.errors,
      })
    }

    if (response?.data?.action === "payment") {
      navigate(response.data.url)
    } else {
      setCompleted(true)
    }
  }

  return (
    <FormContainer>
      <Heading rmaType="upgrade-shipping" />
      <Text mb={2}>
        Please select a different {jewlr_t("terms.shipping")} method below:
      </Text>
      <Text fontWeight="500">
        Your Current {jewlr_t("terms.Shipping")} Method:
      </Text>
      <Typography fontSize="20px" fontWeight="700" lineHeight="26px">
        {orderData.order.current_shipping_method.description} &ndash;{" "}
        {orderData.order.current_shipping_method.estimated_delivery_date}
      </Typography>
      <Divider bg="grey.20" my={4} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormWrapper>
          <Typography fontSize="20px" fontWeight="500" lineHeight="20px" mb={2}>
            Upgrade Your {jewlr_t("terms.Shipping")} Method to:
          </Typography>
          {orderData.new_ship_methods.length > 0 ? (
            <ShipMethods
              available_ship_methods={orderData.new_ship_methods}
              control={control}
              order={orderData.order}
            />
          ) : (
            <>
              <Text fontWeight="700">
                No faster {jewlr_t("terms.shipping")} method is available
              </Text>
              <Text fontWeight="500">
                Please contact customer service at{" "}
                <Typography
                  as="a"
                  href={`tel:${sl.config.customer_service_toll_free}`}
                >
                  {sl.config.customer_service_toll_free}
                </Typography>{" "}
                or{" "}
                <Typography
                  as="a"
                  href={`mailto:${sl.config.customer_service_email}`}
                >
                  {sl.config.customer_service_email}
                </Typography>{" "}
                for assistance.
              </Text>
            </>
          )}
        </FormWrapper>
        {orderData.new_ship_methods.length > 0 && (
          <InputWrapper>
            <SubmitButton
              data-cy="order-upgrade-shipping-btn"
              disabled={!isValid}
              loading={isSubmitting}
            >
              Continue
            </SubmitButton>
          </InputWrapper>
        )}

        <InputWrapper>
          <CancelButton data-lc="order-form" to="/">
            Cancel and Continue Shopping
          </CancelButton>
        </InputWrapper>
        {errors?.root?.error && (
          <Typography color="error" mb={1}>
            {errors.root.error.message}
          </Typography>
        )}
      </form>
    </FormContainer>
  )
}

OrderForm.propTypes = {
  orderData: PropTypes.object,
  setCompleted: PropTypes.func,
}

export default OrderForm
